'use strict';
import * as $j_app$002edata$002etypes$005fdrug$0024package$0024$002dDrug$002dRequest$002dId$0024$002dWith$002dPharmacy$002dId from "./app.data.types_drug$package$-Drug-Request-Id$-With-Pharmacy-Id.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$$anon$56(evaluator$34) {
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$56__f_evaluator$10 = null;
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$56__f_evaluator$10 = evaluator$34;
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$$anon$56 as $c_Lapp_api_GeneralPracticeAppUpdate$$anon$56 };
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$56.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$56.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$56;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$$anon$56() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$$anon$56 as $h_Lapp_api_GeneralPracticeAppUpdate$$anon$56 };
$h_Lapp_api_GeneralPracticeAppUpdate$$anon$56.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$56.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$56.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$56.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_GeneralPracticeAppUpdate$$anon$56__f_evaluator$10.apply__O();
  return ((v instanceof $j_app$002edata$002etypes$005fdrug$0024package$0024$002dDrug$002dRequest$002dId$0024$002dWith$002dPharmacy$002dId.$c_Lapp_data_types\uff3fdrug$package$DrugRequestId$WithPharmacyId) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$56.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_GeneralPracticeAppUpdate$$anon$56 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$$anon$56, "app.api.GeneralPracticeAppUpdate$$anon$56", ({
  Lapp_api_GeneralPracticeAppUpdate$$anon$56: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$$anon$56 as $d_Lapp_api_GeneralPracticeAppUpdate$$anon$56 };
//# sourceMappingURL=app.api.-General-Practice-App-Update$$anon$56.js.map
